import React, { Component } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";

class Accordion01 extends Component {
  render() {
    return (
      <Accordion className="accodion-style--1" preExpanded={["0"]}>
        <AccordionItem uuid="0">
          <AccordionItemHeading>
            <AccordionItemButton>
              Fethiye On Grid Sistemleri
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              Şebekeye bağlı güneş enerjisi sistemlerinin kurulumunu, ihtiyaca
              uygun şekilde planlayıp güvenli bağlantılarla devreye alıyoruz. Ev
              ve iş yerleri için sade ve verimli çözümler sunuyoruz.
            </p>
          </AccordionItemPanel>
        </AccordionItem>

        <AccordionItem uuid="1">
          <AccordionItemHeading>
            <AccordionItemButton>
              Fethiye Elektrik Proje Çizimi
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              Elektrik projelerinizi yürürlükteki yönetmeliklere uygun şekilde
              hazırlar, uygulama öncesi tüm detayları netleştiririz. Doğru
              proje, sorunsuz bir kurulumun temelidir.
            </p>
          </AccordionItemPanel>
        </AccordionItem>

        <AccordionItem uuid="2">
          <AccordionItemHeading>
            <AccordionItemButton>
              Fethiye Şarj Kontrol Ünitesi
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              Akü ve enerji sistemlerinin daha verimli ve güvenli çalışması için
              şarj kontrol ünitelerinin kurulum ve bağlantı işlemlerini
              titizlikle gerçekleştiriyoruz.
            </p>
          </AccordionItemPanel>
        </AccordionItem>

        <AccordionItem uuid="3">
          <AccordionItemHeading>
            <AccordionItemButton>Fethiye Güneş Panelleri</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              Güneş panellerinin keşif, kurulum ve bağlantı süreçlerini
              alanınıza ve ihtiyacınıza göre planlıyoruz. Uzun ömürlü ve düzenli
              çalışan sistemler kurmayı hedefliyoruz.
            </p>
          </AccordionItemPanel>
        </AccordionItem>

        <AccordionItem uuid="4">
          <AccordionItemHeading>
            <AccordionItemButton>Fethiye Sulama Sistemleri</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              Tarla ve bahçeler için elektrikli sulama sistemlerinin bağlantı ve
              kontrol altyapısını güvenli şekilde kuruyor, sistemin düzenli
              çalışmasını sağlıyoruz.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    );
  }
}

export default Accordion01;
